"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./EmployeeCalculator.css");

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _Propulator = _interopRequireDefault(require("../../../higher-order/Propulator"));

var _formatters = _interopRequireDefault(require("../../../util/formatters"));

var _d = _interopRequireDefault(require("d3"));

var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));

var _times = _interopRequireDefault(require("lodash/times"));

var _class, _class2, _class3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

var EmployeeCalculator = (0, _mobxReact.observer)(_class = (_class2 = (_class3 = /*#__PURE__*/function (_React$Component) {
  _inherits(EmployeeCalculator, _React$Component);

  var _super = _createSuper(EmployeeCalculator);

  function EmployeeCalculator() {
    _classCallCheck(this, EmployeeCalculator);

    return _super.apply(this, arguments);
  }

  _createClass(EmployeeCalculator, [{
    key: "getScales",
    value: function getScales() {
      var props = this.props;
      var x = props.loan.term / 12 * 1.25;
      var y = props.loan.balance * 1.25;
      return {
        x: _d.default.scale.linear().domain([0, x]).range([props.marginLeft, props.chartWidth]),
        y: _d.default.scale.linear().domain([0, y]).range([props.chartHeight - props.marginBottom, 0])
      };
    }
  }, {
    key: "renderCurve",
    value: function renderCurve() {
      var _this$props = this.props,
          loan = _this$props.loan,
          stats = _this$props.stats;
      var defaultTermYears = loan.term / 12;
      var extraPaymentTermYears = stats.extraPaymentTerm / 12;

      var _this$getScales = this.getScales(),
          x = _this$getScales.x,
          y = _this$getScales.y; // need to make sure that we don't have more interpolation points than years or the curve will get crazy and fold back on itself


      var numInterpolationPoints = Math.min(extraPaymentTermYears, 5);
      var defaultSampleSize = Math.floor(loan.term / numInterpolationPoints);
      var extraPaymentSampleSize = Math.floor(stats.extraPaymentTerm / numInterpolationPoints);

      var getPoints = function getPoints(principal, sampleSize, termYears) {
        return [{
          x: 0,
          y: loan.balance
        }].concat( // if numInterpolationPoints = 5, we want to sample from points 1/5, 2/5 and 3/5 into the data, and add this to the actual
        // start and end points
        (0, _times.default)(numInterpolationPoints - 1, function (i) {
          return {
            // the monthly principal value is *after* the first payment has been made, so adjust everything by 1 month on the graph
            x: ((i + 1) * sampleSize + 1) / 12,
            y: principal[(i + 1) * sampleSize]
          };
        })) // put the rest of the points at the bottom so that we always have a consistent number -- ensures that
        // transitions are smoother if there is a big change to the inputs
        .concat((0, _times.default)(6 - numInterpolationPoints, function () {
          return {
            x: termYears,
            y: 0
          };
        }));
      };

      var defaultPoints = getPoints(stats.defaultMonthlyPrincipal, defaultSampleSize, defaultTermYears);
      var extraPoints = getPoints(stats.monthlyPrincipal, extraPaymentSampleSize, extraPaymentTermYears);

      var chart = _d.default.select(this.chart).select(".chart");

      var renderSingleCurve = function renderSingleCurve(className, data) {
        var curve = chart.select(".curve-container").selectAll(".".concat(className)).data(data); // Enter

        curve.enter().append("g").attr("class", className).append("path").attr("class", "curve-path").attr("d", _d.default.svg.line().x(function (d) {
          return x(d.x);
        }).y(function (d) {
          return y(d.y);
        }).interpolate("basis")); // Update

        curve.select("path").transition().attr("d", _d.default.svg.line().x(function (d) {
          return x(d.x);
        }).y(function (d) {
          return y(d.y);
        }).interpolate("basis"));
      };

      renderSingleCurve("curve-default", [defaultPoints]);
      renderSingleCurve("curve-extra", [extraPoints]);
    }
  }, {
    key: "renderAxes",
    value: function renderAxes() {
      var _this$props2 = this.props,
          marginLeft = _this$props2.marginLeft,
          marginBottom = _this$props2.marginBottom,
          chartHeight = _this$props2.chartHeight;

      var _this$getScales2 = this.getScales(),
          x = _this$getScales2.x,
          y = _this$getScales2.y;

      var chart = _d.default.select(this.chart).select("g");

      chart.selectAll(".x-axis").call(_d.default.svg.axis().scale(x).tickSize(5, 0).tickFormat(_formatters.default.prettyNumberWithDecimalsIfNecessary).tickValues(x.ticks(10).map(function (i) {
        return i;
      }).slice(1)).orient("bottom")).attr("transform", "translate(0, ".concat(chartHeight - marginBottom, ")"));
      chart.selectAll(".x-axis text").attr("y", 10);
      chart.selectAll(".y-axis").call(_d.default.svg.axis().scale(y).tickSize(5, 0).tickFormat(_formatters.default.prettyWholeNumber).tickValues(y.ticks(7).map(function (i) {
        return i;
      }).slice(1, -1)).orient("left")).attr("transform", "translate(".concat(marginLeft, ", 0)"));
      chart.selectAll(".y-axis text").attr("x", -10);
    }
  }, {
    key: "createChart",
    value: function createChart() {
      var _this$props3 = this.props,
          marginLeft = _this$props3.marginLeft,
          marginBottom = _this$props3.marginBottom,
          chartHeight = _this$props3.chartHeight;

      var chart = _d.default.select(this.chart).append("g").attr("class", "chart");

      chart.append("g").attr("class", "curve-container");
      chart.append("g").attr("class", "x-axis axis");
      chart.append("g").attr("class", "y-axis axis");
      var axisLabelX = marginLeft - 6;
      chart.append("text").attr("class", "x-axis-label").attr("x", axisLabelX).attr("y", chartHeight - marginBottom / 2 - 3).attr("text-anchor", "end").append("tspan").text("TIME LEFT (YR)");
      var secondRowDeltaY = 15;
      var yLabel = chart.append("text").attr("class", "y-axis-label").attr("y", 15);
      yLabel.append("tspan").text("OUTSTANDING").attr("x", axisLabelX).attr("text-anchor", "end");
      yLabel.append("tspan").text("PRINCIPAL ($)").attr("text-anchor", "end").attr("x", axisLabelX).attr("dy", secondRowDeltaY);
      var withLabelX = 170;
      var withLabel = chart.append("text").attr("class", "label with-label").attr("y", 275);
      withLabel.append("tspan").text("With SLP Plan").attr("text-anchor", "start").attr("x", withLabelX);
      withLabel.append("tspan").text("Contributions").attr("text-anchor", "start").attr("x", withLabelX).attr("dy", secondRowDeltaY);
      var withoutLabelX = 480;
      var withoutLabel = chart.append("text").attr("class", "label without-label").attr("y", 160);
      withoutLabel.append("tspan").text("Without SLP Plan").attr("text-anchor", "start").attr("x", withoutLabelX);
      withoutLabel.append("tspan").text("Contributions").attr("text-anchor", "start").attr("x", withoutLabelX).attr("dy", secondRowDeltaY);
    }
  }, {
    key: "updateChart",
    value: function updateChart() {
      if (!this.props.invalidMonthlyPayment) {
        this.renderCurve();
        this.renderAxes();
      }
    }
  }, {
    key: "_update",
    value: function _update() {
      if (!this._createdChart) {
        this.createChart();
        this._createdChart = true;
      }

      this.updateChart();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this._update(); // This fixes an IE bug: svg elements are focusable, but they don't have a blur method, so the
      // slider can't be dragged after clicking on the chart.


      this.chart.setAttribute("focusable", "false");
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._update();
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var refFunction = function refFunction(el) {
        return _this.chart = el;
      }; // eslint-disable-line no-return-assign


      return /*#__PURE__*/_react.default.createElement("div", {
        className: "calculator"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "scaling-svg-container"
      }, /*#__PURE__*/_react.default.createElement("svg", {
        className: this.props.className,
        viewBox: "0 0 700 350",
        ref: refFunction
      })));
    }
  }]);

  return EmployeeCalculator;
}(_react.default.Component), _defineProperty(_class3, "defaultProps", {
  chartWidth: 700,
  chartHeight: 350,
  marginBottom: 40,
  marginLeft: 150
}), _class3), (_applyDecoratedDescriptor(_class2.prototype, "renderCurve", [_autobindDecorator.default], Object.getOwnPropertyDescriptor(_class2.prototype, "renderCurve"), _class2.prototype)), _class2)) || _class;

var _default = (0, _Propulator.default)(EmployeeCalculator, {
  impactCalculatorStore: ["loan", "extraPayment", "stats", "invalidMonthlyPayment"]
});

exports.default = _default;